import { RiCheckboxCircleLine, RiCloseFill, RiAlertLine } from 'react-icons/ri';
import { Modal, Button } from '~/components';
import { DeletDiv, Content, TitleModal } from './styles';

interface IProps {
  children: any;
  onClick: () => void;
  success: boolean;
}

const ModalDefalut: React.FC<IProps> = ({
  children,
  onClick,
  success,
}: IProps) => {
  return (
    <Modal>
      <DeletDiv success={success}>
        <TitleModal>
          <button type="button" onClick={onClick}>
            <RiCloseFill />
          </button>
        </TitleModal>
        <Content>
          {success ? <RiCheckboxCircleLine /> : <RiAlertLine />}
          <b>{success ? 'Sucesso!' : 'Erro'}</b>
          <p>{children}</p>
          <Button onClick={onClick}>Entendi!</Button>
        </Content>
      </DeletDiv>
    </Modal>
  );
};

export default ModalDefalut;
